import { createAction } from "typesafe-actions";
import { OtherScoreCompletedReport } from "types";

export const addStudentId = createAction(
  "OTHER_SCORES/STUDENT_ID_ADD",
)<string>();

export const addReport = createAction(
  "OTHER_SCORES/REPORT_ADD",
)<OtherScoreCompletedReport>();

export const setIntervalId = createAction(
  "OTHER_SCORES/INTERVAL_ID_SET",
)<number>();
